import { render } from "./dcc-info.vue?vue&type=template&id=971a76a6&scoped=true"
import script from "./dcc-info.vue?vue&type=script&lang=js"
export * from "./dcc-info.vue?vue&type=script&lang=js"

import "./dcc-info.vue?vue&type=style&index=0&id=971a76a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-971a76a6"]])

export default __exports__